import React from "react";

/**
 * ThreeDotIcon Component
 * Reusable three-dot menu icon SVG
 */
const ThreeDotIcon = ({ onClick, className = "dropdown-toggle1" }) => {
  return (
    <div className={className} onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="4"
        height="20"
        viewBox="0 0 4 20"
        fill="none"
      >
        <circle cx="2" cy="2" r="2" fill="#96A8BA" />
        <circle cx="2" cy="10" r="2" fill="#96A8BA" />
        <circle cx="2" cy="18" r="2" fill="#96A8BA" />
      </svg>
    </div>
  );
};

export default ThreeDotIcon;
